module.exports = __webpack_public_path__ + "img/p-15-2.afc5ebd3.png";